export const headerText = (email: string | undefined) =>
  email ? `Account settings for ${email}` : 'Account settings';

export const fullName = (firstName: string, lastName: string) => [firstName, lastName].join(' ');
